import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {QuizSessionDb} from './quizSessionDbSchema';
import {QuizSession, quizSessionSchema} from './quizSessionSchema';

export function mapQuizSessionDbToType(db: FirestoreDocSnapshotWithIdAndData<QuizSessionDb>): QuizSession {
  const data = mapFirestoreDocWithTimestamp(db);
  return quizSessionSchema.parse(data);
}
